const mailcheck = require('mailcheck');
const config = require(`./config/${process.env.NODE_ENV}`).default

var embedded_email = config.embedded_email;
var embedded_url = config.embedded_url;
var popin_email = config.popin_email;
var popin_gistId = config.popin_gistId;
var popin_url = config.popin_url;

mailcheck.run({
  // see 'usage without jQuery' above.
});
$(document).ready(function(){
  $(window).scroll(function(){
    if( !$('.menu-white').length == 0 ){
      changeColorMenu();
    }
  });

    $.ajaxSetup({
        headers: {'X-CSRF-Token': $("#csrf").val()}
    });
    let refreshingCaptcha = false
    let registrationPending = false
    const updateRegistrationControls = () => {
      const disabled = refreshingCaptcha || registrationPending
      $('#refresh-captcha, #api-register button[type="submit"]').prop('disabled', disabled)
    }
    const refreshCaptcha = () => {
      if (refreshingCaptcha) return
      refreshingCaptcha = true
      updateRegistrationControls()
      $('#captcha-answer').val('')
      return $.get('/api/captcha').done(function (response) {
        $('#captcha').html(response.captcha)
        $('#captcha-answer').trigger('focus')
      }).fail(function (req) {
        $('#captcha').empty()
        $(".alert").hide()
        if (req.status === 429) {
          $("#fail_captcha_limit").show("slow")
        } else {
          $("#registration_error").show("slow")
        }
      }).always(function () {
        refreshingCaptcha = false
        updateRegistrationControls()
      })
    }
    $('#refresh-captcha').on('click', function () {
      if (registrationPending) return
      $(".alert").hide()
      refreshCaptcha()
    })
    //Widget embedded
    if ($("iframe").data("widget") == "embedded") {
        $("iframe").attr("width", $("#iframe").width());
        $("iframe").attr("height", $("#iframe").height());
    }

    if (document.getElementById("modal-arrow")) {
      document.querySelector('#modal-arrow').addEventListener('click', () => {
        $('#mjml-banner-popin').modal('hide');
      })
    }

    $("form#api-register").submit(function (e){
      e.preventDefault()
      if (refreshingCaptcha || registrationPending) return
      registrationPending = true
      updateRegistrationControls()
      const form = $(this)
      const values = {
        _csrf: form.find('input[name="_csrf"]').val(),
        email: form.find('input[name="email"]').val(),
        captcha: form.find('input[name="captcha-answer"]').val(),
      }
      
      $.ajax({
        type: 'POST',
        url: '/api/secure-form',
        data: values,
      }).done(function () {
        $(".alert").hide()
        $("#success_api_subscribe").show("slow")
        $('#api-form-container').hide()
      }).fail(function (req, status, errorThrown) {
        const message = req.responseJSON && req.responseJSON.message
        if (req.status === 400 && message === 'INVALID_CAPTCHA') {
          refreshCaptcha()
          $(".alert").hide()
          $("#fail_api_subscribe").show("slow")
        } else if (req.status === 400 && message === 'INVALID_EMAIL') {
          $(".alert").hide()
          $("#invalid_api_email").show("slow")
        } else if (req.status === 403 && message === 'CAPTCHA_LIMIT_REACHED') {
          $(".alert").hide()
          $("#fail_captcha_limit").show("slow")
        } else {
          if (message !== 'INVALID_EMAIL' && message !== 'CAPTCHA_UNAVAILABLE') refreshCaptcha()
          $(".alert").hide()
          $("#registration_error").show("slow")
        }
      }).always(function () {
        registrationPending = false
        updateRegistrationControls()
      })
    })


  $('body').keypress( function (e) {
        var email = $("#w-preview-fields-content-cell-field-email").val();
        var regex = /\S+@\S+\.\S+/;
        var isEmail = regex.test(email);

    if (email && e.which == 13 && isEmail) {
            if ($("#subscribe-button-content-popin").length) {
                var data = {};
                data[popin_email] = $("#w-preview-fields-content-cell-field-email").val();
                data[popin_gistId] = $("#w-preview-fields-content-cell-field-46609").val();
                data.url = popin_url

                $.ajax({
                   type: "POST",
                   url: '/subscribe-now',
                   data: data,
                   success: function(result){
                       $(".alert").hide();
                       $("#success_subscribe").show("slow");
                   },
                }).fail(function (request,status,errorThrown) {
                    $(".alert").hide();
                    $("#fail_subscribe").show("slow");
                });
                
            } else {
                var data = {};
                data[embedded_email] = $("#w-preview-fields-content-cell-field-email").val();
                data.url = embedded_url
                $.ajax({
                   type: "POST",
                   url: '/subscribe-now',
                   data: data,
                   success: function(result){
                       $(".alert").hide();
                       $("#success_subscribe").show("slow");
                       var date = new Date();
                        date.setTime(date.getTime()+(30*24*60*60*1000));
                        var expires = "; expires="+date.toGMTString();
                        document.cookie = "dismiss-popin=true"+expires;
                   },
                }).fail(function (request,status,errorThrown) {
                    $(".alert").hide();
                    $("#fail_subscribe").show("slow");
                });
            }
    } else if (!$("#w-preview-fields-content-cell-field-email").val() && e.which == 13) {
            $(".alert").hide();
            $("#empty_email").show("slow");
        } else if (!isEmail && e.which == 13) {
            $(".alert").hide();
            $("#email_type").show("slow");
        }
  });
});

window.onresize = function(event) {
    if ($("iframe").data("widget") == "embedded") {
        $("iframe").attr("width", $("#iframe").width());
        $("iframe").attr("height", $("#iframe").height());
    }
};

function changeColorMenu() {
  var $s2Top = $('#section-2').offset().top;
  var $scroll = $(document).scrollTop();
  if( $scroll > $s2Top ){
    $('.menu-white').addClass('black');
    $('.menu-white .logo').attr('src', '/assets/img/logo-small.png');
    $('.menu-white .LtoR-white').removeClass().addClass('LtoR-orange');
  }else {
    $('.menu-white').removeClass('black');
    $('.menu-white .logo').attr('src', '/assets/img/logo-white-small.png');
    $('.menu-white .LtoR-orange').removeClass().addClass('LtoR-white');
  }
}
$(function(){
    $("[data-hide]").on("click", function(){
        $(this).closest("." + $(this).attr("data-hide")).hide();
    });
});
